<template>
  <div v-if="isOpen" class="modal-backdrop fade show modern-backdrop"></div>

  <div class="modal fade" :class="{ show: isOpen }" tabindex="-1" v-show="isOpen" style="display: block;">
    <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content custom-shadow rounded-4" v-if="safeConcessionaire">

        <div class="modal-header border-bottom-0 pt-4 px-4 pb-0">
          <h4 class="modal-title font-weight-bold text-dark d-flex align-items-center">
            <div class="icon-box bg-primary-soft text-primary mr-3">
              <i class="fas fa-building"></i>
            </div>
            Usuarios de {{ safeConcessionaire.business_name }}
          </h4>
          <button type="button" class="close modern-close" @click="closeModal" aria-label="Cerrar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body px-4 py-4">
          <div class="mb-5">
            <div class="d-flex align-items-center mb-3 pb-2 border-bottom modern-border">
              <h5 class="font-weight-bold text-secondary mb-0 mr-2">Administradores</h5>
              <span class="badge badge-pill badge-primary-soft text-primary">
                {{ safeConcessionaire.administrators.length }}
              </span>
            </div>
            <UserTable v-if="safeConcessionaire.administrators.length > 0" :users="safeConcessionaire.administrators" />
            <EmptyMessage v-else />
          </div>

          <div class="mb-2">
            <div class="d-flex align-items-center mb-3 pb-2 border-bottom modern-border">
              <h5 class="font-weight-bold text-secondary mb-0 mr-2">Usuarios</h5>
              <span class="badge badge-pill badge-primary-soft text-primary">
                {{ safeConcessionaire.users.length }}
              </span>
            </div>
            <UserTable v-if="safeConcessionaire.users.length > 0" :users="safeConcessionaire.users" />
            <EmptyMessage v-else />
          </div>
        </div>

        <div class="modal-footer border-top-0 px-4 pb-4 pt-0">
          <button type="button" class="btn btn-light font-weight-bold text-secondary px-4" @click="closeModal">
            Cerrar
          </button>
        </div>
      </div>

      <div v-else class="modal-content custom-shadow rounded-4 border-0">
        <div class="modal-body d-flex flex-column align-items-center justify-content-center py-5 min-vh-50">
          <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <h5 class="text-muted font-weight-bold">Obteniendo información...</h5>
          <p class="text-black-50 small">Por favor, aguarda un momento.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserTable from './UserTable.vue'
import EmptyMessage from './EmptyMessage.vue'

export default {
  components: {
    UserTable,
    EmptyMessage
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    concessionaire: {
      type: Object,
      required: true,
      default: () => ({
        business_name: '',
        administrators: [],
        users: []
      })
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  },
  computed: {
    safeConcessionaire() {
      return this.concessionaire ? {
        business_name: this.concessionaire.business_name || 'Concesionario',
        administrators: Array.isArray(this.concessionaire.administrators)
          ? this.concessionaire.administrators
          : [],
        users: Array.isArray(this.concessionaire.users)
          ? this.concessionaire.users
          : []
      } : null;
    }
  },
}
</script>

<style scoped>
.modal-content {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  border: none;
}

.modal-body {
  overflow-y: auto;
  flex: 1;
}

.custom-shadow {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.rounded-4 {
  border-radius: 1rem !important;
}

.modern-backdrop {
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
}

.icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 1.2rem;
}

.bg-primary-soft {
  background-color: rgba(13, 110, 253, 0.1);
}

.badge-primary-soft {
  background-color: rgba(13, 110, 253, 0.1);
  font-size: 0.9rem;
  padding: 0.35em 0.65em;
}

.modern-close {
  opacity: 0.5;
  transition: opacity 0.2s ease;
  font-size: 1.75rem;
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modern-close:hover {
  opacity: 1;
  color: #dc3545;
}

.modern-border {
  border-color: #f1f5f9 !important;
}

.min-vh-50 {
  min-height: 50vh;
}
</style>